import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=1813faf3&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1813faf3')) {
      api.createRecord('1813faf3', component.options)
    } else {
      api.reload('1813faf3', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=1813faf3&", function () {
      api.rerender('1813faf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Users.vue"
export default component.exports